import { useContext } from 'react'
import { TenantContext, type TenantContextValue } from './TenantContext'

/**
 * Returns tenant context from the nearest `TenantThemeProvider`.
 * Defaults to `{ tenant: 'dhl', setTenant: noop }` outside the provider.
 */
export function useTenant(): TenantContextValue {
  return useContext(TenantContext)
}
